import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type TranslatedStringDataFragment = (
  { __typename: 'TranslatedString' }
  & Pick<SchemaTypes.TranslatedString, 'defaultValue'>
  & { overrides: Array<(
    { __typename: 'TranslatedStringOverrides' }
    & Pick<SchemaTypes.TranslatedStringOverrides, 'value' | 'languagePackId'>
  )> }
);

export const TranslatedStringDataFragmentDoc = /*#__PURE__*/ gql`
    fragment TranslatedStringData on TranslatedString {
  defaultValue
  overrides {
    value
    languagePackId
  }
}
    `;